import { useIsUserSignedIn } from "../../../core_stores/useAuthStore";

export default function WelcomeFreeToTryInfo() {
  const isUserSignedIn = useIsUserSignedIn();

  if (isUserSignedIn) {
    return null;
  }

  return (
    <div
      className="flex items-center justify-center px-4
        text-sm text-center text-light-placeholder dark:text-dark-placeholder z-10"
    >
      Free to try with Google Sign-In — no credit card required
    </div>
  );
}
